import { Heading, Button } from '@simplywallst/ui-core/next';
import EarningsReportOutline from '@simplywallst/ui-core/icons/EarningReportOutline';
import DividendOutline from '@simplywallst/ui-core/icons/DividendOutline';
import PriceUpOutline from '@simplywallst/ui-core/icons/PriceUpOutline';
import InsiderUpOutline from '@simplywallst/ui-core/icons/InsiderUpOutline';
import NewRiskOutline from '@simplywallst/ui-core/icons/NewRiskOutline';
import { useNewsFeed } from './hooks/useNewsFeed';
import { getTotalNewsPerType } from './utils';

type Props = {
  portfolioId: string;
};

export const NewsFeed = ({ portfolioId }: Props) => {
  const { data } = useNewsFeed(portfolioId);

  const totalNewsPerType = getTotalNewsPerType(data);

  return (
    <>
      <div className="grid grid-cols-[max-content_max-content] grid-rows-[max-content] justify-between items-center h-x8">
        <Heading as="h2" size="small">
          Updates <span className="text-softer text-tiny">Last 30d</span>
        </Heading>
        <Button variant="outline" size="medium">
          All Updates
        </Button>
      </div>
      <div className="grid grid-cols-[repeat(5,max-content)] justify-center gap-x1">
        <div className="flex items-center">
          <EarningsReportOutline className="fill-brand-01 w-x3" />
          <div className="text-sm pl-x0_5 pr-x2">
            {totalNewsPerType.HasReportedEarnings || 0}
          </div>
        </div>
        <div className="flex items-center">
          <DividendOutline className="fill-brand-01 w-x3" />
          <div className="text-sm pl-x0_5 pr-x2">
            {totalNewsPerType.HasUpcomingDividend || 0}
          </div>
        </div>
        <div className="flex items-center">
          <PriceUpOutline className="fill-brand-01 w-x3" />
          <div className="text-sm pl-x0_5 pr-x2">
            {totalNewsPerType.HasPriceTargetChanged || 0}
          </div>
        </div>
        <div className="flex items-center">
          <InsiderUpOutline className="fill-brand-01 w-x3" />
          <div className="text-sm pl-x0_5 pr-x2">
            {totalNewsPerType.HasRecentInsiderTransactions || 0}
          </div>
        </div>
        <div className="flex items-center">
          <NewRiskOutline className="fill-brand-01 w-x3" />
          <div className="text-sm pl-x0_5 pr-x2">
            {totalNewsPerType.HasNewRisk || 0}
          </div>
        </div>
      </div>
    </>
  );
};
